
import TaskFactory from "../../../../lib/html5-software-library/src/ranj/util/executor/TaskFactory";
import AssetLibrary from "../../app/assetloading/AssetLibrary";
import AssetLoadServiceEvent from '../../app/assetloading/AssetLoadServiceEvent';
import Config from "../../app/config/Config";
import AssetLoadService from "../assetloading/AssetLoadService";
import AbstractCommand from "../core/AbstractCommand";
import ContextEvent from "../core/ContextEvent";
import Startup from "./Startup";


/**
 * StartupCommand.js
 * 
 * Created on 16-sep-2013, 13:10:08
 *
 * @author Ivo Swartjes for Ranj
 **/
export default class StartupCommand extends AbstractCommand {

    /**
     * @param {soma.EventDispatcher} dispatcher - the soma EventDispatcher
     * @param {Startup} startup 
     * @param {AssetLoadService} assetLoadService 
     * @param {AssetLibrary} assetLibrary 
     * @param {Object} preloadAssetGroups 
     * @param {Config} config 
     * @param {TaskFactory} taskFactory 
     */
    constructor(dispatcher, startup, assetLoadService, assetLibrary, preloadAssetGroups, config) {
        super(dispatcher);
        this._startup = startup;
        this._dispatcher = dispatcher;
        this._assetLoadService = assetLoadService;
        this._assetLibrary = assetLibrary;
        this._preloadAssetGroups = preloadAssetGroups;
        this._config = config;

        this._handlePreloadComplete = this.handlePreloadComplete.bind(this);
    }

    execute(event) {
        // initialize log
        log.info("[StartupCommand]", "Startup command executed", this._dispatcher);

        //Set default values for variables to resolve in asset paths:
        this._assetLoadService.setVariablesToResolveInPaths({LOCALIZED_ASSETS: "assets"});

        // Load splash assets. (Before loading, common assets such as config.json will also be loaded by the assetLoadService.)
        this._dispatcher.addEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handlePreloadComplete);
        this._assetLoadService.loadGroups.apply(this._assetLoadService, this._preloadAssetGroups);
    }

    handlePreloadComplete(event) {
        this._dispatcher.removeEventListener(AssetLoadServiceEvent.LOAD_COMPLETE, this._handlePreloadComplete);

        this._initConfig();

        //Listen to the ContextEvent.PRELOAD_COMPLETE to add project specific tasks to startup sequence
        this._dispatcher.dispatch(ContextEvent.PRELOAD_COMPLETE);

        //... and start executing
        this._startup.execute();
    }

    _initConfig() {
        var configJSON = this._assetLibrary.getAsset("config");
        this._config.setPropertiesFromObject(configJSON);
    }


}